import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailInfoboxComponent } from '../../components/email-infobox/email-infobox.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';
import { MailgunMarkAsHtmlPipe } from '../../pipes/mailgun-mark-as-html.pipe';

@Component({
  selector: 'email-join-company-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './join-company.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailInfoboxComponent,
    MailgunMarkAsHtmlPipe,
    EmailMailgunIfDirective,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class JoinCompanyTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<JoinCompanyTemplateData>;
}

export type JoinCompanyTemplateData = {
  title: string;
  p1: string;
  avatar_url: string;
  message_html: string;
  p2: string;
  button_link: string;
  button_text: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
  privacy_policy_html: string;
};

export const JoinCompanyTemplateMocks: JoinCompanyTemplateData[] = [
  {
    title: 'Hi Jane 👋',
    p1: 'Olivia Novak invited you to the ACME team in Recruitee. ',
    avatar_url: 'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
    message_html: '<p>This is custom <b>message from admin</b> hello!</p>',
    p2: 'Recruitee is a leading Talent Acquisition Platform, designed for recruiters and hiring managers alike.',
    button_link: 'http://recruitee.com',
    button_text: 'Join your team now',
    footer: {
      text: 'Need help?',
      label: 'Contact us',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      target: '_blank',
    },
    privacy_policy_html:
      "By clicking 'Join your team now' you confirm that you have read Recruitee's <a href=\"http://recruitee.com\">Privacy Policy</a>.",
  },
];
